import { getSlideData } from 'chalktalk-react/apis/learn_hub';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { LearnhubSlideData } from '../types';

const handleError = (error: { message: string }) => {
  toast.error(`Something went wrong: ${error.message}`);
  console.error(error.message);
};

const useGetSlideInfo = (slideId: string) =>
  useQuery<LearnhubSlideData>(['lessonSlides', slideId], () => getSlideData(slideId), {
    suspense: false,
    onError: handleError,
    enabled: Boolean(slideId),
    refetchOnMount: true,
    cacheTime: 0,
  });

export default useGetSlideInfo;
